module.exports = __webpack_public_path__ + "img/icon-in-progress.ae9f007c.svg";